import { render, staticRenderFns } from "./CorporationRow.vue?vue&type=template&id=037de95e&scoped=true&"
import script from "./CorporationRow.vue?vue&type=script&lang=js&"
export * from "./CorporationRow.vue?vue&type=script&lang=js&"
import style0 from "./CorporationRow.vue?vue&type=style&index=0&id=037de95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037de95e",
  null
  
)

export default component.exports